import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { ManageAccountsIcon } from '../atoms/Icons';
var ManageCommunityManager = function (_a) {
    var handleClick = _a.handleClick;
    var t = useTranslation().t;
    return (React.createElement(IconButton, { onClick: handleClick, "aria-label": "Manage Community Manager", size: "large" },
        React.createElement(Tooltip, { title: t('buttons.manageCommunityManager') || '' },
            React.createElement(ManageAccountsIcon, null))));
};
export default ManageCommunityManager;
